import NoteIcon from "@mui/icons-material/StickyNote2Outlined";
import { useFormik } from "formik";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { toFormikValidationSchema } from "zod-formik-adapter";
import commonStyles from "./Common.module.css";
import EditControls from "./EditControls";
import TextInput from "./inputs/TextInput";

function AddNote({ onSubmitNote, validationSchema }: AddNoteProps) {
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const formik = useFormik<AddNoteFormState>({
        initialValues: emptyState,
        validationSchema: toFormikValidationSchema(validationSchema),
        onSubmit: async (values) => {
            try {
                setIsLoading(true);
                await onSubmitNote(values.text!);
                setIsOpen(false);
            } finally {
                setIsLoading(false);
            }
        },
    });

    const open = () => {
        formik.resetForm({ values: emptyState });
        setIsOpen(true);
    };

    const cancel = () => setIsOpen(false);

    return isOpen ? (
        <div>
            <TextInput formik={formik} label="" name="text" placeholder="Enter note..." />
            <div className={commonStyles.modalControls}>
                <div className={commonStyles.controlGroup}></div>
                <div className={commonStyles.controlGroup}>
                    <EditControls
                        isStateChanged={formik.dirty}
                        isUpdateLoading={isLoading}
                        onUpdate={formik.handleSubmit}
                        onCancel={cancel}
                    />
                </div>
            </div>
        </div>
    ) : (
        <div className={commonStyles.row}>
            <div></div>
            <div className={commonStyles.button} onClick={open}>
                <NoteIcon fontSize="small" /> Add Note
            </div>
        </div>
    );
}

export default observer(AddNote);

interface AddNoteProps {
    onSubmitNote: (text: string) => Promise<void>;
    validationSchema: any;
}

interface AddNoteFormState {
    text: string | null;
}

const emptyState: AddNoteFormState = { text: null };
